import React, { useState, useEffect } from 'react';
import { makeStyles } from 'tss-react/mui';
import Place from './Place';
import PlaceForm from './PlaceForm';

const useStyles = makeStyles()(() => ({
  places: {
    paddingTop: '5px',
    paddingBottom: '5px',
  },
}));

interface PlaceContainerProps {
  updatePlace: (place: string | null) => void;
  showPlace: boolean;
  place: string | null;
}

const PlaceContainer = ({ updatePlace, showPlace, place }: PlaceContainerProps) => {
  const { classes } = useStyles();

  const [currentPlace, setCurrentPlace] = useState<string | null>(
    place !== null ? place : null,
  );

  const addPlace = (input: string) => {
    setCurrentPlace(input);
  };

  const removePlace = () => {
    setCurrentPlace(null);
  };

  useEffect(() => {
    updatePlace(currentPlace);
  }, [currentPlace]);

  return (
    <div>
      <div className={classes.places}>
        {showPlace && currentPlace !== null && (
          <Place place={currentPlace} removePlace={removePlace} />
        )}
        {showPlace && <PlaceForm addPlace={addPlace} />}
      </div>
    </div>
  );
};

export default PlaceContainer;
